import ScormResults from '../scorm/ScormResults'
import { getScormResults } from './userDetailsService'
import { useResource } from '../../lib/useResource'
import { ErrorState, LoadingState, DeniedState } from '../../components/States'
import { scormStrings as S } from '../scorm/strings'

export default function ScormUserResults({ userId }) {
  const { data, loading, error } = useResource((signal) => getScormResults(userId, signal), [userId])
  if (loading) return <LoadingState />
  if (error?.denied) return <DeniedState />
  if (error) return <ErrorState title={S.error} />
  return <ScormResults results={data ?? []} />
}
